export const safeParse = (json: string) => {
  try {
    return { type: 'ok' as const, value: JSON.parse(json) };
  } catch (e) {
    return { type: 'error' as const, error: e };
  }
};

export const parseWithFallback = (json: string, fallback: unknown) => {
  try {
    return JSON.parse(json);
  } catch (e) {
    return fallback;
  }
};
